import { Suspense, memo, useMemo, type VFC } from 'react'
import { hasExposedNamespace, lazyImportComponent } from '../../framework/microApps'
import NavErrorBoundary from '../common/NavErrorBoundary'
import { useRootElementClassNameLayoutEffect } from '../common/appEffects'
import type { AuthState, StateRef, Vars } from '../../framework/stateTypes'
import type { Location } from 'history'

const LazyComp = lazyImportComponent('scm_main_layout.content_top', 'MSPTenantBreadcrumbs')
const MSPTenantBreadcrumbs: VFC<{ auth: AuthState, vars: Vars, location: Location }> = ({ auth, vars }) => {
  const hidden = useMemo(() => (
    !vars.msp_top_breadcrumbs || (vars.msp_top_breadcrumbs === 'msp-only' && !vars.msp) ||
    !auth.tsgs.hasMsp || !auth.tsgs.hasParentOrSubTenants(auth.tsg_id)
  ), [auth.tsg_id, auth.tsgs, vars.msp, vars.msp_top_breadcrumbs])

  useRootElementClassNameLayoutEffect(hidden ? '' : 'scm-with-content-top')

  return hidden ? null : (
    <Suspense fallback={null}>
      <aside className='spf-flex-0 empty:spf-hidden'>
        <LazyComp auth={auth} />
      </aside>
    </Suspense>
  )
}

const NavTopBar: VFC<{ stateRef: StateRef, auth: AuthState, vars: Vars, location: Location }> = ({ auth, vars, location }) => {
  return hasExposedNamespace('scm_main_layout.content_top') ? (
    <NavErrorBoundary context='scm_main_layout.content_top'>
      <MSPTenantBreadcrumbs auth={auth} vars={vars} location={location} />
    </NavErrorBoundary>
  ) : null
}

export default memo(NavTopBar)
